import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { REALMARK_META } from "./meta.ts";
import { parseRealmarkDetailHtml } from "./parser.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

// Realmark listing pages return 200 but no listing URLs — JS-rendered
// like Place. Route Brightdata-first to render in a real browser.
export const REALMARK_ADAPTER = defineSoldOnlyAdapter(REALMARK_META, buildSearchUrl, {
  brightdataDiscoveryFirst: true,
  parseDetailHtml: parseRealmarkDetailHtml,
  // Direct fetch served its search and detail pages in full (probe, 2026-10-14).
  directFirst: true,
  // Slow under load (search page ~8 s unloaded); 30 s timed out during backfills.
  directTimeoutMs: 60_000,
});
